import { Auth, GoogleAuthProvider, signInWithPopup } from "@firebase/auth";
import React from "react";
import { Button, Card } from "react-bootstrap";
import { useAuth, useSigninCheck } from "reactfire";

export interface SignInFormProps {}

const signIn = async (auth: Auth) => {
	const provider = new GoogleAuthProvider();

	await signInWithPopup(auth, provider);
};

const SignInForm: React.FC<SignInFormProps> = ({}) => {
	const auth = useAuth();

	return (
		<Card className="signin" title="Sign in form">
			<div className="deco">
				<h3 className="display">Polarizing Express</h3>
				<Button onClick={() => signIn(auth)}>
					<div className="deco">Sign in with Google</div>
				</Button>
			</div>
		</Card>
	);
};

export default SignInForm;
